export const whoisredmer = `
#### How would you describe yourself?
I'm Redmer Nauta, a passionate software developer and dog walker.
<br />
<br />  

#### What's the most rewarding part of helping people with diabetes through your work?
One of my inspirations for working for OSC is: "Healthy people are happy people." In other words, one of my passions is to deliver better health to people.
<br />
<br />  

#### What have you learned about diabetes and open-source looping since joining the team?
I've seen how much effort it takes for people with diabetes to take their health under their own control. It sickens me to see how many loops one has to go through when taking an alternative route for better health. (No puns intended)
<br />
<br />  

#### Where do you see the future of diabetes over 10 years?
I see a future where people can easily set up a looping system which they benefit from health-wise and thus mood-wise!
<br />
<br />  

<!-- blog-contact-footer -->
`;
